import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { LoaderService } from './services/loader.service'
import { UserService } from './services/user.service'
import { MessageService } from './services/message.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-choose',
    templateUrl: '/choose.component.html'
})

export class ChooseComponent implements OnInit {
    myDataShops: any;
    myDataLatestShops: any;
    welcome: string;

  constructor(public http: HttpClient, private router: Router, private loaderService: LoaderService, private userService: UserService, private messageService: MessageService ) {
     this.userService.welcome().subscribe(data => this.welcome = data);// user name
  }


  subscriptions: Subscription[] = []

    
    loadLatestShop() {
        this.loaderService.emitChange(true);
       
        this.http.get('/Admin/UserShops').subscribe((res: any) => {
            this.myDataLatestShops = res;
            this.loaderService.emitChange(false);

        });
    }

    launchShop(shop: any) {
      localStorage.setItem("Shop", shop.Id);
      //need to set the store in the profile too...

      this.router.navigate(['/shopservices']);


      
    }

    loadShops() {
        this.loaderService.emitChange(true);
        var myUrl: string = '/Resources2/ShopsList';
        this.http.get(myUrl).subscribe((res: any) => {
                this.myDataShops = res;
                this.loaderService.emitChange(false);
            });
    }

    public ngOnInit(): any {
        localStorage.removeItem('Shop');
        //localStorage.removeItem('Brand');
        this.loadLatestShop();
        this.loadShops()
    }
}
